export default __webpack_public_path__ + "static/media/Snake Slit.26cdca60.png";